import { useSelector } from "react-redux";
import { selectAccountBookSettings } from "../../../../store/selectors/clientSettingsSelectors";
import LedgerAccountsContainer from "./LedgerAccountsContainer";
import LedgerAccountsMultiBookContainer from "./LedgerAccountsMultiBookContainer";
import type { ChartOfAccounts, MeasureDescriptor } from "../../../../../../../../api/types/svTypes.ts";

interface Props {
  chartOfAccounts: ChartOfAccounts | undefined;
  measure: MeasureDescriptor;
}
const LedgerAccountsWrapper = (props: Props) => {
  const accountingBookSettings = useSelector(selectAccountBookSettings);

  return (
    <>
      {!accountingBookSettings?.multiBook && <LedgerAccountsContainer {...props} />}
      {accountingBookSettings?.multiBook && <LedgerAccountsMultiBookContainer {...props} />}
    </>
  );
};

export default LedgerAccountsWrapper;
